import * as React from 'react'
import { cn } from 'lib/utils'

const Avatar = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(
	({ className, ...props }, ref) => (
		<span
			ref={ref}
			className={cn(
				'relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full',
				className,
			)}
			{...props}
		/>
	),
)
Avatar.displayName = 'Avatar'

interface AvatarImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {}

const AvatarImage = React.forwardRef<HTMLImageElement, AvatarImageProps>(
	({ className, src, ...props }, ref) => {
		const [hasError, setHasError] = React.useState(false)

		React.useEffect(() => {
			setHasError(false)
		}, [src])

		if (!src || hasError) return null

		return (
			<img
				ref={ref}
				src={src}
				className={cn('absolute inset-0 h-full w-full object-cover', className)}
				onError={() => setHasError(true)}
				{...props}
			/>
		)
	},
)
AvatarImage.displayName = 'AvatarImage'

const AvatarFallback = React.forwardRef<HTMLSpanElement, React.HTMLAttributes<HTMLSpanElement>>(
	({ className, ...props }, ref) => (
		<span
			ref={ref}
			className={cn(
				'flex h-full w-full items-center justify-center rounded-full bg-muted',
				className,
			)}
			{...props}
		/>
	),
)
AvatarFallback.displayName = 'AvatarFallback'

export { Avatar, AvatarImage, AvatarFallback }
